<template>
    <el-dialog
        title="修改价格"
        :visible.sync="priceDialogVisible"
        :close-on-click-modal="false"
        width="1000px" class="addressDialog">
        <div class="logisticsDialog">
            <el-form ref="logisticsForm" class="demo-ruleForm">
                <el-scrollbar style="height: 500px">
                    <div class="addressList">


                    </div>
                </el-scrollbar>
                <el-form-item class="submitButtonGroup">
                    <el-button type="primary" @click="priceSubmit">确定</el-button>
                    <el-button @click="priceDialogVisible = false">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
import { updateOrderShopBaseInfo, } from '../../../utils/interface';
export default {
    name: "orderShopPrice",
    data(){
        return{
            // 取消订单
            priceDialogVisible:false,
            orderBaseInfo:{},
        }
    },
    methods: {
        init(item){
            this.orderBaseInfo = item;
            this.priceDialogVisible = true;
        },
        // 修改价格
        priceSubmit(){
            updateOrderShopBaseInfo(this.orderBaseInfo).then((res)=>{
                if(res.success){
                    this.$message.success('价格修改成功！');
                    this.priceDialogVisible = false;
                    this.$emit('updateOrderSuccess');
                }
            });
        },
    }
}
</script>

<style scoped lang="less">
.addressDialog{
    /deep/.el-dialog__header{
        border-bottom: 1px solid #ddd;
    }
    /deep/.el-dialog__body{
        padding: 0;
    }
    .submitButtonGroup{
        text-align: right;
        margin-bottom: 0;
        border-top: 1px solid #ddd;
        padding: 10px 30px;
    }
}
.addressList{
    padding: 24px 30px 20px;
    display: flex;
    flex-wrap: wrap;
    .addressItem{
        padding: 14px 22px;
        margin-bottom: 24px;
        margin-right: 30px;
        position: relative;
        width: 270px;
        border-radius: 8px;
        border: 2px dashed #E3E3E3;
        font-size: 14px;
        .addressBorder{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
        &.active{
            border: 2px dashed #fff;
        }
        &:nth-of-type(4n){
            margin-right: 0;
        }
        .checkBox{
            position: absolute;
            right: 22px;
            top: 14px;
        }
        .name{
            color: #000;
        }
        .tel{
            color: rgba(51, 51, 51, 0.85);
            padding: 6px 0;
        }
        .address{
            color: rgba(51, 51, 51, 0.85);
            line-height: 22px;
        }
    }
    .addItem{
        text-align: center;
        cursor: pointer;
        color: #666;
        &:hover{
            border: 2px dashed #1890FF;
        }
        .icon{
            font-size: 30px;
        }
        .addName{
            font-size: 14px;
            padding-top: 5px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/orderShopPrice.vue